import {ElMessage} from 'element-plus'

//table 鼠标hover样式
export function tableRowInterlaceStyle(row) {
    // console.log(row)
    return row.rowIndex % 2 === 1 ? {background: '#ECF5FFFF'} : {background: '#fff'}
}

//根据索引获取参数
export function getParamByIndex(index) {
    let url = window.location.href
    if (url.indexOf('?') > 0) {
        url = url.substring(0, url.indexOf('?'))
    }
    const list = url.split('/')
    // console.log('getParamByIndexVal:' + list[index + 2])
    console.log(list)
    return list[index + 2]
}

//数字金额转汉字大写
export const changeNumMoneyToChinese = (n) => {
    const fraction = ['角', '分']
    const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
    const unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']]
    const head = n < 0 ? '欠' : ''
    n = Math.abs(n)

    let s = ''

    for (let i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '')
    }
    s = s || '整'
    n = Math.floor(n)

    for (let i = 0; i < unit[0].length && n > 0; i++) {
        let p = ''
        for (let j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p
            n = Math.floor(n / 10)
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整')
}

export const getWeekDayName = (dateStr) => {
    const date = new Date(dateStr);
    const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    // getDay() 返回 0-6，正好对应数组的索引
    return weeks[date.getDay()];
}

//去除html标签
export const erasureHtml = (html) => {
    if (html != null && html != '') {
        html = html.replace(new RegExp('<.+?>|&.+?', 'g'), '')
        return html.replace(/[\r\n]/g, '')
    } else {
        return ''
    }
}

//金额去掉第一个字符和逗号，并转成浮点
export const amtToFloat = (amt) => {
    if (amt || amt === 0) {
        //第一个字符不是数字
        if (isNaN(parseInt(amt.toString().charAt(0)))) {
            return parseFloat(amt.toString().slice(1).replaceAll(',', ''))
        } else {
            return parseFloat(amt.toString().replaceAll(',', ''))
        }
    } else {
        return ''
    }
}

//千位分隔符
export const amtFormat = (amt) => {
    if (amt || amt === 0) {
        const amtStr = amt.toString()
        const profit = amtStr.charAt(0) === '￥' ? '' : '￥'
        return profit + amtStr.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
    } else {
        return ''
    }
}

//将字符串转换为千分位金额格式，并保留最多两位小数
export const formatThousandsAmt = (str, sp = 2) => {
    //仅保留数字和小数点
    if (typeof str !== 'string') str = str + ''
    str = str.replace(/[^\d.]/g, '')
    if (!str || str.length === 0) {
        return '0'
    }

    let [integerPart, decimalPart] = str.split('.')
    //去除多余的0，只保留第一个小数点
    integerPart = parseInt(integerPart).toString()
    //最多保留两位小数
    decimalPart = decimalPart ? decimalPart.slice(0, sp) : ''
    if (decimalPart.length < sp) {
        decimalPart = decimalPart.padEnd(sp, '0')
    }
    //对整数部分进行千分位分隔
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    if (sp > 0) {
        return integerPart + '.' + decimalPart
    } else {
        return integerPart
    }
}

// 表单序列化
export const dayBegin = date => {
    if (typeof date != 'object') {
        if (('' + date).length === 10) date = parseInt(date) * 1000
        date = new Date(date)
    }
    return parseTime(new Date(date), '{y}-{m}-{d} 00:00:00')
}
// 表单序列化
export const dayEnd = date => {
    if (typeof date != 'object') {
        if (('' + date).length === 10) date = parseInt(date) * 1000
        date = new Date(date)
    }
    return parseTime(new Date(date), '{y}-{m}-{d} 23:59:59')
}
// 表单序列化
export const serialize = data => {
    const list = []
    Object.keys(data).forEach(ele => {
        list.push(`ele}=data[ele]}`)
    })
    return list.join('&').replace(/\+/g, '%2B')
}

export function storeUnitChange(bytes) {
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let unitIndex = 0;

    while (bytes >= 1024 && unitIndex < units.length - 1) {
        bytes /= 1024;
        unitIndex++;
    }
    return `${bytes.toFixed(2)}${units[unitIndex]}`;
}

export function calDaysBetweenDates(date1, date2) {
    // 将输入的日期字符串转换为Date对象
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    // 计算两个日期的毫秒数差值
    const differenceInMilliseconds = Math.abs(d2 - d1);
    // 将毫秒数差值转换为天数
    const differenceInDays = differenceInMilliseconds / (1000 * 3600 * 24);
    // 返回计算出的天数
    return differenceInDays;
}

export function minusDaysToDate(date, days) {
    // 创建一个新的Date对象，避免修改原始日期
    const newDate = new Date(date);
    // 将天数转换为毫秒数
    const millisecondsInDay = 24 * 60 * 60 * 1000;
    // 计算新的日期
    newDate.setTime(newDate.getTime() - days * millisecondsInDay);
    // 返回新的日期
    return newDate;
}

export function addDaysToDate(date, days) {
    // 创建一个新的Date对象，避免修改原始日期
    const newDate = new Date(date);
    // 将天数转换为毫秒数
    const millisecondsInDay = 24 * 60 * 60 * 1000;
    // 计算新的日期
    newDate.setTime(newDate.getTime() + days * millisecondsInDay);
    // 返回新的日期
    return newDate;
}

export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'number') && (time.toString().length === 10)) time = parseInt(time) * 1000
        if (time.toString().length === 8) {
            time = time.toString().substring(0, 4) + '-' + time.toString().substring(4, 6) + '-' + time.toString().substring(6, 8)
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key]
        if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
        if (result.length > 0 && value < 10) {
            value = '0' + value
        }
        return value || 0
    })
    return time_str
}

/**
 * 将时间戳（毫秒）转换为 yyyy-MM-dd 格式的字符串
 * @param {number} timestamp - 时间戳（毫秒）
 * @returns {string} 格式化后的日期字符串
 */
export function formatTimestampToDate(timestamp) {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以+1，并确保两位数
    const day = String(date.getDate()).padStart(2, '0'); // 确保两位数

    return `${year}-${month}-${day}`;
}

export function formatShortTime(time, option) {
    time = +time * 1000
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) { // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
}

export function setDocumentTitle(title) {
    document.title = title
    const ua = navigator.userAgent
    // eslint-disable-next-line
    const regex = /\bMicroMessenger\/([\d\.]+)/
    if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
        const i = document.createElement('iframe')
        i.src = '/favicon.ico'
        i.style.display = 'none'
        i.onload = function () {
            setTimeout(function () {
                i.remove()
            }, 9)
        }
        document.body.appendChild(i)
    }
}

/**
 *
 * @param list  待转换的list    (必填)
 * @param tree  转换后的树      (必填)
 * @param parentId  父类ID 值  (必填)
 * @param idDataLabel id 字段  (必填)
 * @param nameDataLabel name 字段
 * @param idLabel     转换后的  id 字段
 * @param nameLabel   转换后的  字name 字段
 * @param parentIdLabel 父类ID 字段
 * @returns tree
 */
export function listToTree(list, tree = [], parentId = '0', parentIdLabel = 'parentId', sourceVal = 'value', sourceLabel = 'label', targetVal = 'value', targetLabel = 'label') {
    list.forEach(item => {
        // 判断是否为父级菜单
        if (item[parentIdLabel] == parentId) {
            const child = {
                ...item, key: item[sourceVal], children: []
            }
            child[targetVal] = item[sourceVal]
            child[targetLabel] = item[sourceLabel]
            // 迭代 list， 找到当前菜单相符合的所有子菜单
            listToTree(list, child.children, item[sourceVal], parentIdLabel, sourceVal, sourceLabel, targetVal, targetLabel)
            // 删掉不存在 children 值的属性
            if (child.children.length <= 0) {
                delete child.children
            }
            // 加入到树中
            tree.push(child)
        }
    })
    return tree
}

// 格式化数字 - 保留2位小数
export function formatNumber(num) {
    if (num === undefined || num === null) return '-';
    // 如果是字符串且包含百分号，直接返回
    if (typeof num === 'string' && num.includes('%')) return num;
    // 转换为数字并保留2位小数
    return Number(num).toLocaleString('zh-CN', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
    });
}

/**
 * 获取url的全部参数
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * 获取url参数
 */
export function getQueryParam(key) {
    return getQueryObject()[key]
}

// 导出Excel
export function exportBlod(fileName, data) {
    if (data.size === 0) {
        ElMessage({
            message: '没有附件', type: 'error'
        })
        return
    }
    const blob = new Blob([data])
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href)
    document.body.removeChild(elink)
}

// 处理请求返回信息
export function handleDownloadBlod(fileName, response) {
    const res = response.data
    if (res.type === 'application/json') {
        const reader = new FileReader()
        reader.readAsText(response.data, 'utf-8')
        reader.onload = function () {
            const {msg} = JSON.parse(reader.result)
            ElMessage({
                message: msg, type: 'error'
            })
        }
    } else {
        exportBlod(fileName, res)
    }
}

/**
 * 获取缓存的值——String类型
 * return  返回获取的值，无返回空
 * 2022-07-21
 * */
export function getLocalStorageStr(key) {
    const val = localStorage.getItem(key)
    return val != undefined && val != null && val ? val : null
}

/**
 * 获取缓存的值——Object类型
 * return 返回JSON对象，否则返回空对象
 * 2022-07-21
 * */
export function getLocalStorageObject(key) {
    const val = localStorage.getItem(key)
    return val != undefined && val != 'undefined' && val != null && val ? JSON.parse(val) : null
}

export function h5Copy(content) {

    if (!document.queryCommandSupported('copy')) {
        // 不支持
        return false
    }

    let textarea = document.createElement("textarea")
    textarea.value = content
    textarea.readOnly = "readOnly"
    document.body.appendChild(textarea)
    textarea.select() // 选择对象
    textarea.setSelectionRange(0, content.length) //核心
    let result = document.execCommand("copy") // 执行浏览器复制命令
    textarea.remove()
    if (result) {
        ElMessage({
            message: '复制成功', type: 'success'
        })
    } else {
        ElMessage({
            message: '复制失败', type: 'error'
        })
    }
    return result
}

/**
 * 四舍五入保留2位小数（不够位数，则用0替补）
 */
export function keepTwoDecimalFull(num) {
    let result = parseFloat(num)
    if (isNaN(result)) {
        alert('传递参数错误，请检查！')
        return false
    }
    result = Math.round(num * 100) / 100
    let s_x = result.toString()
    let pos_decimal = s_x.indexOf('.')
    if (pos_decimal < 0) {
        pos_decimal = s_x.length
        s_x += '.'
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0'
    }
    return s_x
}

/**
 * 获取 静态资源
 * @param url
 * @returns {*}
 */
export function getAssetsFile(url) {
    return require(`../assets/${url}`)
}

// 添加日期范围
export function addDateRange(params, dateRange, propName) {
    params = typeof (params) === 'object' && params !== null && !Array.isArray(params) ? params : {}
    dateRange = Array.isArray(dateRange) ? dateRange : []
    if (typeof (propName) === 'undefined') {
        params['startCreateTime'] = dateRange[0]
        params['endCreateTime'] = dateRange[1]
    } else {
        params['start' + propName] = dateRange[0]
        params['end' + propName] = dateRange[1]
    }
    return params
}

export function generateRoutes(menus) {
    if (!menus) menus = []
    const routes = []
    menus.forEach(menu => {
        const route = {
            path: menu.menuPath, name: menu.menuName, component: () => import(`@/views${menu.menuPath}`), meta: {
                title: menu.menuName, tag: menu.menuName
            }
        }
        if (menu.menuType == 1) {
            route.component = () => import(`@/layout/BasicLayout`)
        }
        if (menu.children && menu.children.length > 0) {
            route.children = generateRoutes(menu.children)
        }
        routes.push(route)
    })
    return routes
}

export const getDatePickerOptions = () => {
    const shortcuts = [{
        text: '今天', value: () => {
            const end = new Date()
            end.setHours(23, 59, 59, 999);
            const start = new Date()
            start.setHours(0, 0, 0, 0);
            return [start, end]
        },
    }, {
        text: '昨天', value: () => {
            const end = new Date()
            const start = new Date()
            end.setDate(end.getDate() - 1);
            end.setHours(23, 59, 59, 999);
            start.setDate(start.getDate() - 1);
            start.setHours(0, 0, 0, 0);
            return [start, end]
        }
    }, {
        text: '最近2天', value: () => {
            const end = new Date()
            end.setHours(23, 59, 59, 999);
            const start = new Date()
            start.setHours(0, 0, 0, 0);
            start.setDate(start.getDate() - 2)
            return [start, end]
        }
    }, {
        text: '本周', value: () => {
            const now = new Date();
            const day = now.getDay();
            const diff = day === 0 ? -6 : 1 - day; // 修正到周一
            const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + diff, 0, 0, 0);
            const end = new Date(now.getFullYear(), now.getMonth(), start.getDate() + 6, 23, 59, 59, 999);
            return [start, end]
        }
    }, {
        text: '上周', value: () => {
            const now = new Date();
            const day = now.getDay();
            // 如果今天是周日(0)，差值是 7+6=13 天；否则是 day + 6 天
            const diff = day === 0 ? 13 : day + 6;
            // 上周一
            const start = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff, 0, 0, 0);
            // 上周日 (上周一 + 6天)
            const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff + 6, 23, 59, 59, 999);
            
            return [start, end]
        }
    }, {
        text: '本月', value: () => {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
            const end = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
            return [start, end]
        }
    }, {
        text: '上一个月', value: () => {
            const now = new Date();
            const start = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0, 0);
            const end = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999); // 当月第0天=上月最后一天
            return [start, end]
        }
    }, {
        text: '上季度',
        value: () => {
            const now = new Date();
            // 当前季度首月减3，就是上季度首月 (如果当前是1月(0)，0-3=-3，JS会自动变成去年10月)
            const qStartMonth = Math.floor(now.getMonth() / 3) * 3 - 3;
            const start = new Date(now.getFullYear(), qStartMonth, 1, 0, 0, 0, 0);
            const end = new Date(now.getFullYear(), qStartMonth + 3, 0, 23, 59, 59, 999);
            return [start, end]
        }
    }, {
        text: '本季度',
        value: () => {
            const now = new Date();
            const qStartMonth = Math.floor(now.getMonth() / 3) * 3;
            const start = new Date(now.getFullYear(), qStartMonth, 1, 0, 0, 0, 0);
            const end = new Date(now.getFullYear(), qStartMonth + 3, 0, 23, 59, 59, 999);
            return [start, end]
        }
    }, {
        text: '最近半年', value: () => {
            const end = new Date()
            const start = new Date()
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            start.setMonth(start.getMonth() - 6)
            return [start, end]
        }
    }, {
        text: '最近一年', value: () => {
            const end = new Date()
            const start = new Date()
            start.setHours(0, 0, 0, 0);
            end.setHours(23, 59, 59, 999);
            start.setFullYear(start.getFullYear() - 1)
            return [start, end]
        }
    }]
    return shortcuts
}
export const getTimePickerOptions = () => {
    const shortcuts = [{
        text: '过去1小时', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 1);
            return [start, end]
        },
    }, {
        text: '过去4小时', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 4);
            return [start, end]
        },
    }, {
        text: '过去12小时', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 12);
            return [start, end]
        },
    }, {
        text: '昨天到今天', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            return [start, end]
        },
    }, {
        text: '最近一周', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        },
    }, {
        text: '最近一个月', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        },
    }, {
        text: '最近三个月', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
        },
    }, {
        text: '过去半年', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 183);
            return [start, end]
        },
    }, {
        text: '过去1年', value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365 * 3);
            return [start, end]
        },
    },]
    return shortcuts
}





